export default __webpack_public_path__ + "static/media/mail_icon_1.ce172ad4.svg";